import { Capacitor } from "@capacitor/core";
import { IsRoot } from "@capgo/capacitor-is-root";

/**
 * Secondary root detection layer via @capgo/capacitor-is-root.
 * Primary security checks (root, Frida, developer options) run
 * natively in MainActivity.onCreate before the WebView loads.
 */

export const checkRootStatus = async () => {
    if (!Capacitor.isNativePlatform()) {
        return {
            isRooted: false,
            isEmulator: false,
            hasRootApps: false,
        };
    }

    try {
        const [rootResult, emulatorResult, rootAppsResult] = await Promise.all([
            IsRoot.isRooted(),
            IsRoot.isRunningOnEmulator(),
            IsRoot.detectRootManagementApps(),
        ]);

        return {
            isRooted: rootResult.result === true,
            isEmulator: emulatorResult.result === true,
            hasRootApps: rootAppsResult.result === true,
        };
    } catch (error) {
        console.error("Root detection error:", error);
        return {
            isRooted: true,
            isEmulator: false,
            hasRootApps: false,
        };
    }
};

export const checkSuBinary = async () => {
    if (!Capacitor.isNativePlatform()) {
        return { hasSuBinary: false };
    }

    try {
        const result = await IsRoot.checkForSuBinary();
        return { hasSuBinary: result.result === true };
    } catch (error) {
        console.error("SU binary check error:", error);
        return { hasSuBinary: true };
    }
};

export const performSecurityCheck = async () => {
    const [rootStatus, suBinaryCheck] = await Promise.all([
        checkRootStatus(),
        checkSuBinary(),
    ]);

    const isSecure = !rootStatus.isRooted &&
        !rootStatus.isEmulator &&
        !rootStatus.hasRootApps &&
        !suBinaryCheck.hasSuBinary;

    return {
        isSecure,
        status: {
            ...rootStatus,
            hasSuBinary: suBinaryCheck.hasSuBinary,
        },
    };
};
